import { useQuery } from '@tanstack/react-query';
import {
  getPermissionByUser,
  getPermissionByRole,
  getAllPermissions,
  getCurrentProfile,
} from '../services/user';
import { getTotalUsers, getUsers } from '../services/admin';

export const useQueryTotalUsers = ({ search, role }) => {
  return useQuery(
    ['totalUsers', { search, role }],
    () => getTotalUsers({ search, role }),
    {
      keepPreviousData: true,
      initialData: 0,
    },
  );
};
export const useQueryGetUsers = ({ page, limit, search, role }) => {
  return useQuery(['users', { page, limit, search, role }], () =>
    getUsers({ page, limit, search, role }),
  );
};

export const useQueryPermissionByUser = userId => {
  return useQuery(
    ['permissionsByUser', { userId }],
    () => getPermissionByUser(userId),
    {
      enabled: !!userId,
      initialData: [],
    },
  );
};

export const useQueryPermissionByRole = role => {
  return useQuery(
    ['permissionsByRole', { role }],
    () => getPermissionByRole(role),
    {
      enabled: !!role,
      initialData: [],
    },
  );
};
export const useQueryAllPermissions = () => {
  return useQuery(['permissions'], getAllPermissions, {
    initialData: [],
  });
};

export const useGetCurrentProfile = () => {
  return useQuery(['me'], getCurrentProfile, {
    initialData: {},
    retry: 0,
  });
};
